/**
 *  版权所有 © 2026 东方闻道 All Rights Reserved
 *
 *  创建者: admin
 *  创建时间: 2026-08-31 09:31
 *  文件名: src/components/ppt-learning-plan-viewer/service.ts
 *  功能描述:
 */

import { orderBy, sortBy } from 'lodash';
import { apiGetApiFileConvertResultFileId } from '../../apis/assignment-file-convert-service/file-convert-controller-v2';
import { FileConvertImageVO } from '../../apis/assignment-file-convert-service/models/file-convert-image-vo';
import { withPolling, parseJson } from 'eastedu-kit';

type ParsedFileConvertImageVO = Omit<FileConvertImageVO, 'results'> & {
  results: Array<{
    order: number;
    fileId: string;
    imgUrl: string;
    imgWidth: number;
    imgHeight: number;
  }> | null;
};

async function getFileConvertResultFileId(
  fileId: string,
): Promise<ParsedFileConvertImageVO | null> {
  const result = await apiGetApiFileConvertResultFileId({ fileId });

  if (!result[0]) return null;

  const firstResult = result[0];

  if (firstResult.status === 'CONVERT_SUCCESS') {
    const parsedResults = parseJson(firstResult.results);
    return {
      ...firstResult,
      results: parsedResults ? orderBy(parsedResults, 'order') : null,
    };
  }
  return { ...firstResult, results: null };
}

/**
 * 带轮询的"PPT 转图片"结果查询接口。
 * 按默认间隔 2s 查询一次转换进度，最多轮询 5 次（约 10s)；
 * 当所有页面均不再处于 CONVERTING 状态（到达终态）时停止轮询，
 * 达到最大次数仍未完成则抛错走降级逻辑。
 */
const getFileConvertResultFileIdWithPooling = withPolling(getFileConvertResultFileId, {
  maxAttempts: 5,
  isPollingComplete(result) {
    return !result || result.status !== 'CONVERTING';
  },
});

export { getFileConvertResultFileIdWithPooling };
